// extracted by mini-css-extract-plugin
module.exports = {"termsAndServices":"_2d7pBPUg4-0wFjG3fMH_kL"};